import { motion } from "framer-motion";

import { HOW_IT_WORKS, VOICE_CREDIT } from "@/data/content";

const ACCENTS = ["#FFDF00", "#FF3B30", "#84E116"];
const STEPS = HOW_IT_WORKS.map((s, i) => ({ ...s, accent: ACCENTS[i] }));

export default function HowItWorks() {
  return (
    <section
      data-testid="how-it-works-section"
      className="bg-[#F2F2F0] border-b-4 border-black py-16 sm:py-24 px-4 sm:px-8 lg:px-16"
    >
      <div className="max-w-[1600px] mx-auto">
        <div className="flex flex-wrap items-end justify-between gap-6 mb-10 sm:mb-14">
          <div>
            <motion.span
              className="inline-block bg-[#0A0A0A] text-[#84E116] font-broadcast font-bold text-[10px] sm:text-xs tracking-[0.3em] uppercase px-4 py-2 mb-4"
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
            >
              Section · How It Works
            </motion.span>
            <motion.h2
              className="font-display uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tight text-black"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
            >
              How It Works
            </motion.h2>
          </div>
          <motion.p
            className="font-broadcast text-[10px] sm:text-xs tracking-[0.2em] uppercase text-black/60 max-w-[260px] text-left sm:text-right"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6, delay: 0.15 }}
            data-testid="voice-credit"
          >
            {VOICE_CREDIT}
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
          {STEPS.map((step, i) => (
            <motion.article
              key={step.id}
              data-testid={`how-it-works-card-${step.id}`}
              className="bg-white border-[3px] border-black hard-shadow-lg p-6 sm:p-8 relative transition-transform duration-200 hover:-translate-y-1.5"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{
                duration: 0.6,
                delay: i * 0.12,
                ease: [0.22, 1, 0.36, 1],
              }}
            >
              <div
                className="w-12 h-12 sm:w-14 sm:h-14 border-[3px] border-black flex items-center justify-center mb-6"
                style={{ backgroundColor: step.accent }}
              >
                <span className="font-display text-xl sm:text-2xl text-black">
                  {step.id}
                </span>
              </div>
              <h3 className="font-broadcast font-extrabold text-xs sm:text-sm tracking-[0.18em] uppercase text-black mb-3">
                {step.title}
              </h3>
              <p className="text-sm sm:text-base font-medium leading-relaxed text-black/70">
                {step.description}
              </p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
